import { graphql } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Block from "../atoms/layout-primitives/block"
import Grid from "../atoms/layout-primitives/grid"
import VariantContainer from "../atoms/variant-container"
import IndustryCard, { IIndustryCard } from "../molecules/industry-card"

export const INDUSTRY_LIST_TYPENAME = "ContentfulIndustryList"

export interface IIndustryList {
  __typename: typeof INDUSTRY_LIST_TYPENAME
  industries: IIndustryCard[]
}

const IndustryList = ({ industries }: Omit<IIndustryList, "__typename">) => {
  return (
    <Grid>
      {industries && (
        <Block
          display={{ sm: "flex" }}
          variants={[
            css`
              flex-wrap: wrap;
              justify-content: center;
              align-items: top;
              gap: 24px;
              & > div {
                flex-basis: 100%;
              }
            `,
            css`
              gap: 32px;
              & > div {
                flex-basis: calc(50% - 16px);
              }
            `,
            css`
              gap: 48px 64px;
              & > div {
                flex-basis: calc(32% - 32px);
              }
            `,
          ]}
        >
          {Array.isArray(industries) &&
            industries.map((industryCard, index) => (
              <IndustryCard key={index} {...industryCard} />
            ))}
        </Block>
      )}
    </Grid>
  )
}

export const IndustryListFragment = graphql`
  fragment ContentfulIndustryList on ContentfulIndustryList {
    contentful_id
    industries {
      ...ContentfulIndustryCard
    }
  }
`
export default IndustryList
